import './Popup.css';

import _ from 'lodash';
import $ from 'jquery';
import Backbone from 'backbone';
import template_Popup from './Popup.ejs';
import {appReady} from 'common/appReady';
import {Key} from 'util/Key';

const $wrapper = $('<div class="PopupViewWrapper"></div>');
const $blockBg = $('<div class="loading-block"></div>');
$blockBg.hide();

appReady.then(() => {
	$('body').append($wrapper);
	$wrapper.append($blockBg)
});

export const Popup = Backbone.View.extend({
	className: "PopupView",
	events: {
		'mousedown .PopupDragArea': "startDragging",
		'mousedown .PopupResizeArea': "startResizing",
		'click .PopupCloseButton': "close",
	},
	/**
	 * @param options
	 * @param options.name Popup name, unique per application
	 * @param options.view self rendering view. defines content gets triggered with events from popup. don't forget to remove view when no longer used
	 * @param options.removeOnClose remove popup after first close event
	 * @param options.purgeOnClose also remove options.view (implicit removeOnClose=true)
	 */
	initialize: function (options) {
		_.bindAll(this, _.functionsIn(this));
		this.status = new Backbone.Model({
			open: false,
			fixed: true,
			dragging: false,
			resizing: false,
			posX: 200,
			posY: 200,
			sizeX: 300,
			sizeY: 300,
			sizeXmin: 100,
			sizeYmin: 80,
			headerHeight: 40, //no event handler
			contentPadding: 10, //no event handler
			blockBackground: options.blockBackground || false,
		});
		this.$el.hide();
		this.$c = {};
		this.name = options.name;
		this.view = options.view;
		this.removeOnClose = options.removeOnClose || options.purgeOnClose || false;
		this.purgeOnClose = options.purgeOnClose || false;
		this.listenTo(this.status, 'change:open change:fixed', this.evtShowHide);
		this.listenTo(this.status, 'change:dragging', this.evtDragging);
		this.listenTo(this.status, 'change:resizing', this.evtResizing);
		this.listenTo(this.status,
			'change:posX change:posY change:sizeX change:sizeY change:sizeXmin change:sizeYmin',
			this.evtSizePos);
		this.listenTo(this.status, 'change:open', this.evtOpen);
		this.render();
		//this.loadSettings();
		//this.listenTo(this.status, 'change', invokeLastFunc(this, 'saveSettings', 200));
		$wrapper.append(this.$el);
	},
	// ****************
	// **** Helper ****
	// ****************
	setSize(sizeHorizontalPx, sizeVerticalPx) {
		this.status.set({sizeX: sizeHorizontalPx, sizeY: sizeVerticalPx});
	},
	setMinSize() {
		this.status.set({sizeXmin: 170, sizeYmin: 120});
	},
	setRelativeSize(sizeHorizontalPercent, sizeVerticalPercent) {
		let sx = this.status.get('sizeX');
		let sy = this.status.get('sizeY');
		if (typeof sizeHorizontalPercent === 'number') sx = $(window).innerWidth() * sizeHorizontalPercent / 100;
		if (typeof sizeVerticalPercent === 'number') sy = $(window).innerHeight() * sizeVerticalPercent / 100;
		if (sizeHorizontalPercent === 'fit') sx = this.view.$el.outerWidth();
		if (sizeVerticalPercent === 'fit') sy = this.view.$el.outerHeight();
		this.status.set({
			sizeX: sx,
			sizeY: sy,
		});
	},
	centerPosition() {
		this.status.set({
			posX: Math.max(0, $(window).innerWidth() - this.$el.outerWidth()) / 2,
			posY: Math.max(0, $(window).innerHeight() - this.$el.outerHeight()) / 2,
		});
	},
	positionTo(el) {
		let $el = $(el);
		if (!$el.length) return;
		let pos = $el.position();
		this.status.set({
			posX: pos.left,
			posY: pos.top,
		});
	},
	// ****************************
	// **** View Event Handler ****
	// ****************************
	startResizing: function (evt) {
		if (evt) this.prevPointer = this.extractPointer(evt);
		this.status.set({resizing: true});
	},
	stopResizing: function () {
		this.status.set({resizing: false});
		console.log(this.status.pick(['sizeX', 'sizeY']));
	},
	startDragging: function (evt) {
		if (evt) this.prevPointer = this.extractPointer(evt);
		this.status.set({dragging: true});
	},
	stopDragging: function () {
		this.status.set({dragging: false});
		console.log(this.status.pick(['posX', 'posY']));
	},
	open: function () {
		this.refreshHeader();
		this.status.set({open: true});
		this.ensureInScreen();
		if (this.status.get('blockBackground')) {
			$blockBg.on('click', this.close);
			$blockBg.show();

		}
	},
	close: function () {
		this.status.set({open: false});
		if (this.status.get('blockBackground')) {
			$blockBg.hide();
			$blockBg.off('click', this.close);
		}
	},
	extractPointer: function (evt) {
		return {clientX: evt.clientX, clientY: evt.clientY};
	},
	ensureInScreen: function () {
		let newStatus = this.calcInScreen(this.status.toJSON());
		this.status.set(newStatus);
	},
	calcInScreen(status) {
		let x = status.posX;
		let y = status.posY;
		let sx = status.sizeX;
		let sy = status.sizeY;
		let minsx = status.sizeXmin;
		let minsy = status.sizeYmin;
		let $win = $(window);
		let screensx = ($win.innerWidth() || 100) - 10;
		let screensy = ($win.innerHeight() || 100) - 10;
		//resize
		if (sx < minsx) sx = minsx;
		else {
			sx = Math.min(sx, screensx);
		}
		if (sy < minsy) sy = minsy;
		else {
			sy = Math.min(sy, screensy);
		}
		//reposition
		if (x < 0) x = 0;
		else {
			x = Math.min(x, screensx - sx);
		}
		if (y < 0) y = 0;
		else {
			y = Math.min(y, screensy - sy);
		}
		return {
			posX: x,
			posY: y,
			sizeX: sx,
			sizeY: sy,
		};
	},
	// *****************************
	// **** Model Event Handler ****
	// *****************************
	evtOpen: function () {
		//only trigger events for view, open logic is in evtShowHide
		let open = this.status.get('open');
		if (open) {
			this.view.trigger('Popup:open');
		} else {
			this.view.trigger('Popup:close');
			if (this.purgeOnClose) this.view.remove();
			if (this.removeOnClose) this.remove();
		}
	},
	evtShowHide: function () {
		let open = this.status.get('open');
		let fixed = this.status.get('fixed');
		if (open) {
			this.bindGlobalHandler(true, 'keydown', this.keyDownCb);
			if (!fixed) this.bindGlobalHandler(true, 'mousedown', this.closeOnBlurCb);
			else this.bindGlobalHandler(false, 'mousedown', this.closeOnBlurCb);
			this.$el.show();
		} else {
			this.bindGlobalHandler(false, 'keydown', this.keyDownCb);
			this.bindGlobalHandler(false, 'mousedown', this.closeOnBlurCb);
			this.$el.hide();
		}
	},
	evtDragging: function () {
		let dragging = this.status.get('dragging');
		if (dragging) {
			this.bindGlobalHandler(true, this.draggingCbEventNames, this.draggingCb);
		} else {
			this.bindGlobalHandler(false, this.draggingCbEventNames, this.draggingCb);
		}
	},
	evtResizing: function () {
		let resizing = this.status.get('resizing');
		if (resizing) {
			this.bindGlobalHandler(true, this.resizingCbEventNames, this.resizingCb);
		} else {
			this.bindGlobalHandler(false, this.resizingCbEventNames, this.resizingCb);
		}
	},
	evtSizePos: function () {
		this.ensureInScreen();
		this.$el.css({
			width: this.status.get('sizeX'),
			height: this.status.get('sizeY'),
			left: this.status.get('posX'),
			top: this.status.get('posY'),
			minWidth: this.status.get('sizeXmin'),
			minHeight: this.status.get('sizeYmin'),
		});
		let offsetWidth = this.status.get('contentPadding') * 2;
		let offsetHeight = this.status.get('headerHeight') + offsetWidth;
		if (this.$c.content) {
			this.$c.content.css({
				width: Math.max(20, this.status.get('sizeX') - offsetWidth),
				height: Math.max(20, this.status.get('sizeY') - offsetHeight),
				minWidth: this.status.get('sizeXmin') - offsetWidth,
				minHeight: this.status.get('sizeYmin') - offsetHeight,
			});
		}
	},
	// ********************************
	// **** Ext Listener Callbacks ****
	// ********************************
	draggingCbEventNames: 'mousemove mouseup',
	draggingCb: function (evt) {
		if (evt.type === 'mouseup') {
			this.stopDragging();
			this.prevPointer = undefined;
			return false;
		}
		let prevPointer = this.prevPointer || this.extractPointer(evt);
		let newPos = {
			posX: this.status.get('posX') + evt.clientX - prevPointer.clientX,
			posY: this.status.get('posY') + evt.clientY - prevPointer.clientY,
		};
		this.prevPointer = this.extractPointer(evt);
		this.status.set(newPos);
		return false;
	},
	resizingCbEventNames: 'mousemove mouseup',
	resizingCb: function (evt) {
		if (evt.type === 'mouseup') {
			this.stopResizing();
			this.prevPointer = undefined;
			return false;
		}
		let prevPointer = this.prevPointer || this.extractPointer(evt);
		//todo other resize regions than se
		let newPos = {
			sizeX: this.status.get('sizeX') + evt.clientX - prevPointer.clientX,
			sizeY: this.status.get('sizeY') + evt.clientY - prevPointer.clientY,
		};
		this.prevPointer = this.extractPointer(evt);
		this.status.set(newPos);
		//todo limit
		return false;
	},
	/////////////// global ////////////////
	closeOnBlurCbEventNames: "click",
	closeOnBlurCb: function (evt) {
		let $target = $(evt.target);
		if (!$target.closest(this.el).length) this.status.set({open: false});
	},
	keyDownCbEventNames: 'keydown',
	keyDownCb: function (evt) {
		//keycode handlings
		switch (evt.key) {
			case Key.Escape:
				this.status.set({open: false});
				return false;
			default:
				return true; //do nothing
		}
	},
	bindGlobalHandler: function (state, event, cb) { //repeatable
		$(document).off(event, null, cb);
		if (state) {
			$(document).on(event, null, cb);
		}
	},
	// ************************
	// ******** Render ********
	// ************************
	template: template_Popup,
	refreshHeader: function () {
		let header;
		if (this.view && typeof this.view.getHeader === 'function') {
			header = this.view.getHeader();
		}
		if (header && header.then) {
			this.$el.find('.PopupHeaderContent').html(" ");
			header.then((txt) => this.$el.find('.PopupHeaderContent').html(txt || " "));
		} else if (header) {
			this.$el.find('.PopupHeaderContent').html(header || " ");
		} else {
			this.$el.find('.PopupHeaderContent').html(this.name || " ");
		}
	},
	render: function () {
		this.$el.html(this.template(this.status.attributes));
		this.refreshHeader();
		this.$c = {
			content: this.$el.find('.PopupContent'),
		};
		this.$c.content.html(this.view.$el || "");
		this.evtSizePos();
		return this;
	},
});

export default Popup;